// extracted by mini-css-extract-plugin
export var boxItems = "_8v-1";
export var boxItemsLg = "_8v-2";
export var button = "_8v-7";
export var buttonHoverless = "_8v-9";
export var buttonLg = "_8v-8";
export var filterGroupBox = "_8v-0";
export var icon = "_8v-3";
export var iconSecondary = "_8v-6";
export var iconWrapper = "_8v-4";
export var iconWrapperLg = "_8v-5";
export var truncatedLabel = "_8v-a";